<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="8" viewBox="0 0 16 8">
        <g fill="none" fill-rule="evenodd" stroke="#44B358" stroke-linecap="round" stroke-width="1.5">
            <path d="M.469 4.156L3.281 6.969M6.156 5.094L8.031 6.969M3.281 6.969L9.367.883M8.031 6.969L14.117.883" transform="translate(1)"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'opened-tick-icon'
}
</script>
